import React from 'react'
import {
  AuthorName,
  BookCategory,
  BookDetails,
  BookName,
  CoverImage,
  IndividualBook,
} from '../style'
import Skeleton from '@components/skeleton'

const BookLoader = () => {
  return (
    <>
      <IndividualBook>
        <CoverImage>
          <Skeleton height={'100%'} width={'100%'} />
        </CoverImage>
        <BookDetails>
          <BookName>
            <Skeleton height={10} width={'50%'} radius={12} />
          </BookName>
          <AuthorName>
            <Skeleton height={10} width={'50%'} radius={12} />
          </AuthorName>
          <Skeleton height={20} width={'20%'} radius={4} />
        </BookDetails>
      </IndividualBook>
    </>
  )
}

export default BookLoader
